<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icon/DrawAnnotations">
<g id="Vector">
<path d="M16.513 13.6433L10.9418 9.96875L14.8535 4.3976C15.9203 2.97518 17.9354 2.50104 19.4764 3.56786C21.0173 4.63467 21.4915 6.76831 20.4246 8.30926L16.513 13.6433Z" fill="#101010"/>
<path d="M13.0755 14.236L9.63796 11.8653L3 21.2296L12.4828 18.3847L11.8901 16.014L13.0755 14.236Z" fill="#101010"/>
</g>
</g>
</svg>
